const headers = [
  'label.name',
  'costs.header_count',
  'label.type',
];

export default headers;
